import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const MAX_ENTRIES = 8;

export const useRecentCompaniesStore = create(
	persist(
		(set) => ({
			recentCompanies: [],
			addRecentCompany: (company) =>
				set((s) => ({
					recentCompanies: [
						{ ...company, viewedAt: new Date().toISOString() },
						...s.recentCompanies.filter((entry) => entry.id !== company.id),
					].slice(0, MAX_ENTRIES),
				})),
			clearRecentCompanies: () => set({ recentCompanies: [] }),
		}),
		{ name: 'b2bhero:recent-companies' },
	),
);
